"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { BsPinFill } from "react-icons/bs";
import QuickNoteCard from "@/components/quick-note-card";
import { Divider } from "@/components/ui";
import { UserTiny } from "@/types/user";
import { quickNoteQueryOptions } from "@/api/provider/user/patient/quick-note-query";
interface Props {
  patient: UserTiny;
}
export default function PinnedMemosSection(t0) {
  const $ = _c(29);
  const {
    patient
  } = t0;
  const patientId = patient.id;
  let t1;
  if ($[0] !== patientId) {
    t1 = quickNoteQueryOptions.list(patientId);
    $[0] = patientId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!patientId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: t4
  } = useQuery(t3);
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== patient || $[6] !== t4) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const quickNotes = t4 === undefined ? [] : t4;
      const pinnedMemos = quickNotes.filter(_temp);
      if (pinnedMemos.length === 0) {
        t10 = null;
        break bb0;
      }
      if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = <Divider />;
        $[13] = t9;
      } else {
        t9 = $[13];
      }
      t7 = "mx-4 mb-2";
      let t11;
      if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = <BsPinFill className="h-3 w-3 text-primary" />;
        $[14] = t11;
      } else {
        t11 = $[14];
      }
      const t12 = pinnedMemos.length > 1 ? "Pinned Memos" : "Pinned Memo";
      if ($[15] !== t12) {
        t8 = <h4 className="mb-2 flex items-center gap-1.5 text-caption-emphasis uppercase tracking-wider text-foreground-secondary">{t11}<span>{t12}</span></h4>;
        $[15] = t12;
        $[16] = t8;
      } else {
        t8 = $[16];
      }
      t5 = "flex flex-col gap-2";
      let t13;
      if ($[17] !== patient) {
        t13 = note => <QuickNoteCard key={note.id} note={note} size="sm" patient={patient} />;
        $[17] = patient;
        $[18] = t13;
      } else {
        t13 = $[18];
      }
      t6 = pinnedMemos.map(t13);
    }
    $[5] = patient;
    $[6] = t4;
    $[7] = t10;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[19] !== t5 || $[20] !== t6) {
    t11 = <div className={t5}>{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7 || $[24] !== t8) {
    t12 = <div className={t7}>{t8}{t11}</div>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <>{t9}{t12}</>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}
function _temp(n) {
  return !n.eventId && n.isPinned;
}